import Auth from './Auth';
import Events from '../Events';

export { OidcProvider, BridgeProvider } from './providers';

const instance = new Auth(Events);

export default instance;



// WEBPACK FOOTER //
// ./src/Auth/index.js